module.exports = __webpack_public_path__ + "static/media/arrow-right.612a7a9c.svg";